import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20vibrant%20and%20artistic%20manga%20reading%20illustration%20with%20stylized%20comic%20panels%20floating%20in%20a%20cosmic%20space%20with%20stars%20and%20colorful%20nebula%2C%20warm%20golden%20and%20coral%20tones%2C%20creative%20and%20modern%20composition%2C%20no%20realistic%20photos%2C%20illustration%20style%20with%20clean%20lines%20and%20vibrant%20energy&width=1600&height=900&seq=hero-bg-comic&orientation=landscape"
        alt="星球漫画 - 免费漫画全集在线免费阅读"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 md:mb-6 leading-tight">
          星球漫画
        </h1>
        <p className="text-base md:text-xl text-white/90 mb-3 max-w-2xl mx-auto leading-relaxed">
          免费漫画全集在线免费阅读，下拉式阅读体验
        </p>
        <p className="text-sm md:text-base text-white/70 mb-8 max-w-xl mx-auto">
          海量免费漫画网站大全 · 免VIP追更全集 · 好看的免费漫画推荐
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/rexue"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-medium text-sm md:text-base transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-fire-line mr-2"></i>开始阅读
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/20 hover:bg-background-50/30 text-white border border-white/30 rounded-full font-medium text-sm md:text-base transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            了解更多
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-white/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}